import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AdminOperations.css";
import { routeCreateClase, routeFindUserByRol } from "./constants";

export const CreateClass = () => {
  const [matriculaClase, setMatriculaClase] = useState("");
  const [nombreClase, setNombreClase] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [matriculaMaestro, setMatriculaMaestro] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [maestros, setMaestros] = useState([]);
  const [cargandoMaestros, setCargandoMaestros] = useState(true);
  const [estaGuardando, setEstaGuardando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const peticionEnProceso = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMaestros = async () => {
      try {
        const response = await axios.get(routeFindUserByRol, {
          params: { role: "Maestro" },
        });
        const lista = response.data?.data ?? response.data ?? [];
        setMaestros(Array.isArray(lista) ? lista : []);
      } catch (error) {
        console.error("Error al cargar maestros:", error);
        setMaestros([]);
        setResultado({
          tipo: "error",
          mensaje: "No fue posible cargar la lista de maestros.",
        });
      } finally {
        setCargandoMaestros(false);
      }
    };

    fetchMaestros();
  }, []);

  const limpiarFormulario = () => {
    setMatriculaClase("");
    setNombreClase("");
    setDescripcion("");
    setMatriculaMaestro("");
    setFechaInicio("");
    setFechaFin("");
  };

  const handleSubmitClass = async (event) => {
    event.preventDefault();

    if (peticionEnProceso.current) {
      return;
    }

    if (fechaFin < fechaInicio) {
      setResultado({
        tipo: "warning",
        mensaje: "La fecha de fin no puede ser anterior a la fecha de inicio.",
      });
      return;
    }

    peticionEnProceso.current = true;
    setEstaGuardando(true);
    setResultado(null);

    try {
      const response = await axios.post(routeCreateClase, {
        nombre_clase: nombreClase,
        descripcion,
        matricula_maestro: matriculaMaestro,
        matricula_clase: matriculaClase,
        fecha_inicio: fechaInicio,
        fecha_fin: fechaFin,
      });

      if (response.data?.success === false || response.data?.error) {
        throw new Error(
          response.data.message ||
            response.data.error ||
            "El servidor no confirmó la creación de la clase.",
        );
      }

      setResultado({
        tipo: "success",
        mensaje: response.data?.message || "La clase se creó correctamente.",
      });
      limpiarFormulario();
    } catch (error) {
      console.error("Error al crear clase:", error);
      const esDuplicado = error.response?.status === 409;
      setResultado({
        tipo: esDuplicado ? "warning" : "error",
        mensaje:
          error.response?.data?.message ||
          error.response?.data?.error ||
          (esDuplicado
            ? "Ya existe una clase con esa matrícula."
            : error.message ||
              "No fue posible crear la clase. Inténtalo de nuevo."),
      });
    } finally {
      peticionEnProceso.current = false;
      setEstaGuardando(false);
    }
  };

  return (
    <div className="admin-operation-page">
      <main className="admin-operation-container admin-operation-container-narrow">
        <header className="admin-operation-header">
          <p className="admin-operation-eyebrow">Administración académica</p>
          <h1>Crear clase</h1>
          <p>
            Define los datos de la materia, asigna al maestro responsable y
            establece su periodo de actividad.
          </p>
        </header>

        <form className="admin-operation-panel" onSubmit={handleSubmitClass}>
          <div className="admin-operation-form-grid">
            <div className="admin-operation-field">
              <label htmlFor="create-class-name">Nombre de la clase</label>
              <input
                id="create-class-name"
                type="text"
                value={nombreClase}
                onChange={(event) => setNombreClase(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-class-id">Matrícula de la clase</label>
              <input
                id="create-class-id"
                type="text"
                value={matriculaClase}
                onChange={(event) => setMatriculaClase(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field admin-operation-field-wide">
              <label htmlFor="create-class-description">Descripción</label>
              <textarea
                id="create-class-description"
                value={descripcion}
                onChange={(event) => setDescripcion(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field admin-operation-field-wide">
              <label htmlFor="create-class-teacher">Maestro responsable</label>
              <select
                id="create-class-teacher"
                value={matriculaMaestro}
                onChange={(event) => setMatriculaMaestro(event.target.value)}
                disabled={cargandoMaestros || estaGuardando}
                required
              >
                <option value="">
                  {cargandoMaestros
                    ? "Cargando maestros..."
                    : "Selecciona un maestro"}
                </option>
                {maestros.map((maestro) => (
                  <option
                    key={maestro.id ?? maestro.matricula}
                    value={maestro.matricula}
                  >
                    {maestro.matricula} - {maestro.nombre} {maestro.apellido}
                  </option>
                ))}
              </select>
              {!cargandoMaestros && maestros.length === 0 && (
                <small>No hay maestros disponibles.</small>
              )}
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-class-start">Fecha de inicio</label>
              <input
                id="create-class-start"
                type="date"
                value={fechaInicio}
                onChange={(event) => setFechaInicio(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-class-end">Fecha de fin</label>
              <input
                id="create-class-end"
                type="date"
                value={fechaFin}
                min={fechaInicio || undefined}
                onChange={(event) => setFechaFin(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>
          </div>

          {resultado && (
            <div
              className={`admin-operation-status admin-operation-status-${resultado.tipo}`}
              role="status"
              aria-live="polite"
            >
              {resultado.mensaje}
            </div>
          )}

          <div className="admin-operation-actions">
            <button
              className="admin-operation-button"
              type="submit"
              disabled={
                cargandoMaestros || maestros.length === 0 || estaGuardando
              }
            >
              {estaGuardando ? "Creando clase..." : "Crear clase"}
            </button>
            <button
              className="admin-operation-button admin-operation-button-secondary"
              type="button"
              onClick={() => navigate("/admin-home")}
              disabled={estaGuardando}
            >
              Regresar al inicio
            </button>
          </div>
        </form>
      </main>
    </div>
  );
};
